<template>
    <div class="device-show__wrapper">
        <div class="app__card_show device-show">
            <div class="app__card-header device-show__card-header">
                <div>{{ device.name }}</div>
                <div class="device-show__applications-badge" @click="showCompatibleApplications">
                    {{ $t("devices.compatibleApplicationsCount", [compatibleApplications.length]) }}
                </div>
                <div>
                    <span
                        v-if="$features.editDevices"
                        class="device-show__icon_space_after"
                        @click="$emit('edit', device)"
                        v-html="$tc('icons.edit')"
                    ></span>
                    <span v-if="$features.deleteDevices" @click="deleteDevice" v-html="$tc('icons.delete')"></span>
                </div>
            </div>
            <div class="app__card-body">
                <application-display-field
                    v-for="field in deviceFields"
                    :key="field.name"
                    :field="field"
                    :data="device"
                ></application-display-field>
            </div>
        </div>
        <device-applications
            v-if="isShowingCompatibleApplications"
            :applications="compatibleApplications"
            :device="device"
            @close="hideCompatibleApplications"
        ></device-applications>
    </div>
</template>

<script>
import {store} from "atom";
import ApplicationDisplayField from "./ApplicationDisplayField";
import DeviceApplications from "./DeviceApplications";
const {createNamespacedHelpers} = store;
const {mapActions, mapState} = createNamespacedHelpers("arcman");
export default {
    name: "device-show",
    props: {
        device: {type: Object, required: true},
    },
    components: {
        ApplicationDisplayField,
        DeviceApplications,
    },
    computed: {
        ...mapState(["applications", "arcologyConstants"]),
        deviceFields() {
            return this.arcologyConstants.DEVICE_FIELDS.filter(field => {
                return field.type !== "custom";
            });
        },
        compatibleApplications() {
            return this.applications.filter(item => {
                if (item.versions?.length) {
                    let functionalRequirements = item.versions[item.currentVersionIndex].functionalRequirements;
                    if (
                        functionalRequirements.length === 0 ||
                        functionalRequirements.reduce((acc, element) => acc && this.capabilitiesSet.has(element), true)
                    ) {
                        return item;
                    }
                }
            });
        },
        capabilitiesSet() {
            let capabilities = new Set();
            if (this.device.capabilities) {
                for (let [key, value] of Object.entries(this.device.capabilities)) {
                    if (value) {
                        capabilities.add(key);
                    }
                }
            }
            return capabilities;
        },
    },
    data: () => {
        return {
            isShowingCompatibleApplications: false,
        };
    },
    methods: {
        ...mapActions({
            destroyDevice: "DEVICE_DESTROY",
        }),
        setDisplayMode(mode) {
            this.displayMode = mode;
        },
        deleteDevice() {
            this.$modal.dialog(this.$t("devices.confirmDelete", {name: this.device.name})).then(confirm => {
                if (confirm) {
                    this.destroyDevice(this.device);
                }
                this.$modal.hide();
            });
        },
        showCompatibleApplications() {
            this.isShowingCompatibleApplications = true;
        },
        hideCompatibleApplications() {
            this.isShowingCompatibleApplications = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.device-show__wrapper::v-deep {
    .device-show {
        border-color: $border-device-card-color;
    }

    .device-show__card-header {
        @apply items-center;
        background-color: $background-device-card-header-color;
    }

    .device-show__applications-badge {
        @apply rounded-full bg-white px-5 py-1;
        color: $text-device-card-header-negative-color;
        &:hover {
            @apply cursor-pointer;
        }
    }

    .device-show__icon_space_after {
        @apply mr-2;
    }

    .application-display-field {
        @apply flex w-full mb-1;
    }

    .application-display-field__label {
        @apply font-bold mr-2;
    }

    .application-display-field__value {
        @apply break-all;
    }
}
</style>
